<template>
  <DsProcessSection
    title=""
    title-id="estrena2-process-title"
    intro=""
    layout="list"
    :columns="3"
    card-variant="compact"
    :steps="steps"
  >
    <template #title><span>¿Cómo es el</span> <span class="hl">proceso?</span></template>
    <template #step-1
      ><p>Revisaremos tu capacidad de pago mediante:</p>
      <p>Comprobantes de ingresos y revisión de buró de crédito.</p></template
    >
    <template #step-2
      ><p>
        Deberás compartir la documentación requerida para completar tu expediente y continuar con la validación de tu
        operación.
      </p></template
    >
    <template #step-3
      ><p>Una vez autorizado tu proceso de adjudicación:</p>
      <p>Programaremos la firma de tu escritura en un plazo aproximado de 15 días.</p></template
    >
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const steps = [
  {
    id: '1',
    title: 'Validación financiera'
  },
  {
    id: '2',
    title: 'Integración de expediente'
  },
  {
    id: '3',
    title: 'Autorización y firma de escritura'
  }
]
</script>
